module.exports = __webpack_public_path__ + "img/kamera-icon.d9e3dad9.svg";